import { SVGProps } from "react";

const VSCDebugStart = (props: SVGProps<SVGSVGElement>) => <svg width="1em" height="1em" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M4.25 3l1.166-.624 8 5.333v1.248l-8 5.334-1.166-.624V3zm1.5 1.401v7.864l5.898-3.932L5.75 4.401z" /></svg>;

export { VSCDebugStart };